"use client";
import { cn } from "@/lib/utils";

export default function SectionHeading({ eyebrow, title, highlight, description, className }) {
  return (
    <div className={cn("text-center mb-14", className)}>
      {eyebrow ? (
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-violet-400 mb-4">
          {eyebrow}
        </p>
      ) : null}
      <h2 className="text-3xl md:text-5xl font-bold text-white">
        {title}{" "}
        {highlight ? (
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-violet-400 to-fuchsia-400">
            {highlight}
          </span>
        ) : null}
      </h2>
      {description ? (
        <p className="text-neutral-400 mt-4 max-w-2xl mx-auto text-base md:text-lg">
          {description}
        </p>
      ) : null}
    </div>
  );
}
